/* Nuvò · Recensioni — filtro per prodotto e «Carica altre recensioni» */
(function () {
  'use strict';

  function initGrid(sec) {
    if (sec.dataset.nrReady) return;
    var grid = sec.querySelector('[data-nr-grid]');
    if (!grid) return;
    sec.dataset.nrReady = '1';
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-nr-card]'));
    var chips = Array.prototype.slice.call(sec.querySelectorAll('[data-nr-chip]'));
    var moreBox = sec.querySelector('[data-nr-more]');
    var moreBtn = moreBox ? moreBox.querySelector('button') : null;
    var step = parseInt(sec.dataset.nrStep, 10) || 6;
    var limit = step;
    var current = '';
    var lastW = window.innerWidth;

    function apply(lock) {
      /* quando si cambia filtro la griglia non si accorcia: il contenuto sotto non salta */
      grid.style.minHeight = lock ? grid.offsetHeight + 'px' : '';
      var shown = 0, total = 0;
      cards.forEach(function (c) {
        var ok = !current || c.dataset.nrP === current;
        if (ok) total += 1;
        var show = ok && shown < limit;
        if (show) shown += 1;
        c.hidden = !show;
      });
      if (moreBox) {
        var none = total <= limit;
        moreBox.style.visibility = none ? 'hidden' : '';
        if (moreBtn) moreBtn.disabled = none;
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        current = chip.dataset.nrChip || '';
        limit = step;
        chips.forEach(function (x) { x.setAttribute('aria-pressed', String(x === chip)); });
        apply(true);
      });
    });
    if (moreBtn) {
      moreBtn.addEventListener('click', function () { limit += step; apply(false); });
    }
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      grid.style.minHeight = '';
    });
    apply(false);
  }

  function init() {
    document.querySelectorAll('[data-nr-rec]').forEach(initGrid);
  }
  window.NuvoRecInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
